import Core from '../Core/Core';
import getLogger, { ILogger } from '../Core/Logger';

const localLogger: ILogger = getLogger('[LOCALISATION]:');

export default class Localisation {
    public languageKey: string;
    private languageData: any;

    constructor() {
        let languageKey = 'en';
        if (sgPlatform === 'fbinstant') {
            const fbLang = FBInstant.getLocale();
            languageKey = fbLang === 'pt_BR' ? 'pt-BR' : fbLang.split('_')[0];
        } else {
            languageKey = Core.sdk.getLocale();
        }
        this.languageKey = languageKey;
        this.setLanguageData(this.getLanguageData(this.languageKey));
    }

    public setLanguageData(languageData: {}) {
        this.languageData = languageData;
    }

    public getText(textKey: string): string {
        if (this.languageData === undefined) {
            localLogger.debug('Language data not found.');
            return textKey;
        }
        const localeString: string = this.languageData[textKey];
        if (localeString === undefined) {
            localLogger.debug(`Language text key '${textKey}'not found`);
            return textKey;
        }
        return localeString;
    }

    public getTextByLanguageID(langKey: string, textKey: string) {
        const langData = this.getLanguageData(langKey);
        if (!langData) {
            localLogger.debug('Language data not found.');
            return textKey;
        } else {
            const localeString: string = langData[textKey];
            if (localeString === undefined) {
                localLogger.debug(`Language text key '${textKey}'not found`);
                return textKey;
            } else {
                return localeString;
            }
        }
    }

    private getLanguageData(langKey: string) {
        return Core.gameCache.jsons[`lang-${langKey}`] || Core.gameCache.jsons['lang-en'];
    }
}
